module.exports = __webpack_public_path__ + "files/b6a4496cd2e213fad143d3b4f921bfc5.svg";